// extracted by mini-css-extract-plugin
export var Map = "Map-module--Map--38AHn";
export var Map__pan_wrapper = "Map-module--Map__pan_wrapper--2V6ui";
export var Map__pin = "Map-module--Map__pin--1hOhz";
export var Map__pinActive = "Map-module--Map__pinActive--4FGP3";
export var Map__tools = "Map-module--Map__tools--1ztRj";
export var Map__slider_container = "Map-module--Map__slider_container--3v4Jg";
export var Map__slider_wrapper = "Map-module--Map__slider_wrapper--1gDef";
export var Map__instruction = "Map-module--Map__instruction--3Ertf";
export var Map__instruction__active = "Map-module--Map__instruction__active--3jnhI";
export var Map__instruction__content_container = "Map-module--Map__instruction__content_container--1FwPS";
export var Map__instruction__touch = "Map-module--Map__instruction__touch--16tsR";
export var Map__instruction__image_container = "Map-module--Map__instruction__image_container--1XLTr";